import React, { FC } from 'react'

import { IconBusinessProps } from './IconBusiness.types'
import * as Styled from './styles/IconBusiness.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBusiness: FC<IconBusinessProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBusinessProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconBusinessProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M144 147.52c-5.61-38-25.17-57.3-45.09-64.39a40 40 0 1 0-37.55.09 60.42 60.42 0 0 0-21.4 13.42c-12.47 12-20.73 29.6-23.87 50.86a4 4 0 1 0 7.91 1.17c5.91-40 28.69-57 49.05-60.2a4 4 0 0 0 3 6.63h2.75a8.36 8.36 0 0 0-7.14 7.42l-4.19 35a4 4 0 0 0 .94 3.08l8.6 10a4 4 0 0 0 6.07 0l8.6-10a4 4 0 0 0 .94-3.08l-4.18-34.91a8.39 8.39 0 0 0-7.15-7.51H84a4 4 0 0 0 2.88-6.76 50 50 0 0 1 28 14.05c11 10.74 18.28 26.75 21.17 46.3a4 4 0 0 0 7.91-1.17zm-64-5.65-4.42-5.14 4-33.34a.44.44 0 0 1 .87.09l4 33.25zm-32-94a32 32 0 1 1 32 32 32 32 0 0 1-32-32z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBusiness
